'use client';

import React from 'react';

interface GalleryFiltersProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const GalleryFilters = ({ categories, activeCategory, onCategoryChange }: GalleryFiltersProps) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 px-4 py-6">
      {categories.map((category) => (
        <button
          key={category}
          type="button"
          onClick={() => onCategoryChange(category)}
          className={`rounded-lg px-6 py-3 text-sm font-medium transition-smooth hover-lift active-press focus-ring ${
            activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-card text-foreground hover:bg-muted'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default GalleryFilters;
